

import {Component, Mixins, Prop} from "vue-property-decorator";
import SimpleInputMixin from "@/mixins/SimpleInputMixin.vue";
import DatabasePicker from "@/components/pickers/DatabasePicker.vue";

@Component({
  components: {DatabasePicker}
})
export default class HacizTuruPicker extends Mixins(SimpleInputMixin) {
  @Prop() rules!: string;
}
